import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './tooltip';

interface InfoIconWithTooltipProps {
  tooltipText: string;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
}

export const InfoIconWithTooltip: React.FC<InfoIconWithTooltipProps> = ({
  tooltipText,
  className = "",
  onClick,
  disabled = false
}) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button 
            aria-label="About the Data" 
            onClick={onClick}
            disabled={disabled}
            className={`group ${className}`}
          >
            <span className="material-symbols-outlined w-6 h-6 text-2xl opacity-70 group-hover:opacity-100 transition-opacity">
              info
            </span>
          </button>
        </TooltipTrigger>
        <TooltipContent className="bg-white text-black border border-gray-200 rounded-lg shadow-lg font-inter" sideOffset={8}>
          <p className="max-w-xs text-sm font-normal">{tooltipText}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
